import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import WarningMessage from '../../../WarningMessage';

const PassengersWarningMessage = ({ className }) => {
  const storeStaterooms = useSelector((store) => store.tripSearch.searchObj.staterooms || []);
  const shouldShowWarning = useMemo(() => storeStaterooms.some((stateRoom) => {
    const {
      children, lapInfants, seatInfants,
    } = stateRoom;
    return children.length > 0 || lapInfants > 0 || seatInfants > 0;
  }), [storeStaterooms]);

  const numberOfAdultsAndSeniors = useMemo(() => storeStaterooms
    .reduce((total, passenger) => total + passenger.adults + passenger.seniors, 0),
  [storeStaterooms]);

  const adultLabel = numberOfAdultsAndSeniors > 1 ? 'guests' : 'guest';

  return shouldShowWarning && (
    <WarningMessage message={`Shopping for children not supported. Showing hotels for ${numberOfAdultsAndSeniors} ${adultLabel}`} className={className} />
  );
};

PassengersWarningMessage.propTypes = {
  className: PropTypes.string,
};

PassengersWarningMessage.defaultProps = {
  className: '',
};
export default PassengersWarningMessage;
